import { UserService } from 'src/app/user/services/user.service';

import { IsNotEmptyObjectPipe } from '../../../../../shared/pipes/is-not-empty-object.pipe';
import { IsNilPipe } from 'src/app/pipes/is-nil.pipe';
import { CountUserProductStationsPipe } from 'src/app/user/pipes/count-user-product-stations.pipe';
import { CountUserProductsPipe } from 'src/app/user/pipes/count-user-products.pipe';
import { EppProductsInListPipe } from 'src/app/user/pipes/epp-products-in-list.pipe';
import { HasUserEopProductPipe } from 'src/app/user/pipes/has-user-eop-product.pipe';
import { HasUserEppProductPipe } from 'src/app/user/pipes/has-user-epp-product.pipe';
import { HasUserProductPipe } from 'src/app/user/pipes/has-user-product.pipe';
import { HasUserProductTypePipe } from 'src/app/user/pipes/has-user-product-type.pipe';
import { HasUserSmwProductPipe } from 'src/app/user/pipes/has-user-smw-product.pipe';
import { HasUserStationPipe } from 'src/app/user/pipes/has-user-station.pipe';

import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  input,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MatCheckboxChange,
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { ClickSectionCheckbox } from '../../models/click-section-checkbox.interface';
import { MatErrorMessagesDirective } from '@wettermanufaktur-gmbh/ui-sdk/directives/mat-error-messages';
import { EgpTypes } from 'src/app/user/models/egp-types.interface';
import { UserStationChange } from 'src/app/user/models/user-station-change.interface';

export const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  MatCardModule,
  FaIconComponent,
  MatFormFieldModule,
  MatInputModule,
  MatDatepickerModule,
  RouterModule,
  MatCheckboxModule,
  MatListModule,
  MatExpansionModule,
  MatButtonModule,
  MatStepperModule,
  TranslateModule,
];
export const PIPES = [
  IsNotEmptyObjectPipe,
  IsNilPipe,
  HasUserEppProductPipe,
  HasUserEopProductPipe,
  HasUserSmwProductPipe,
  HasUserProductPipe,
  CountUserProductStationsPipe,
  EppProductsInListPipe,
  CountUserProductsPipe,
  HasUserStationPipe,
  HasUserProductTypePipe,
];
export const DIRECTIVES = [MatErrorMessagesDirective];

@Component({
  selector: 'app-users-tab-website',
  templateUrl: './users-tab-website.component.html',
  styleUrls: ['../../../../user-admin.component.scss'],
  imports: [...MODULES, ...PIPES, ...DIRECTIVES],
})
export class UsersTabWebsiteComponent {
  newUser = input<boolean>();
  isSaving = input<boolean>();
  contingents = input<any>();
  buttonsTemplate = input<TemplateRef<any>>();
  productList = input<any>();
  eopTypes = input<string[]>();
  egpTypes = input<EgpTypes>();
  clickSectionCheckbox = output<ClickSectionCheckbox>();
  clickAllProducts = output<ClickSectionCheckbox>();
  expandedChanged = output<string>();
  userStationChange = output<UserStationChange>();
  userProductChange = output<UserStationChange>();
  cancel = output();
  summarizeUser = output();

  accordionEppOnline = viewChild<MatAccordion>('accordionEppOnline');
  accordionEopOnline = viewChild<MatAccordion>('accordionEopOnline');
  accordionEgpOnline = viewChild<MatAccordion>('accordionEgpOnline');
  accordionEgwOnline = viewChild<MatAccordion>('accordionEgwOnline');
  accordionSmwOnline = viewChild<MatAccordion>('accordionSmwOnline');
  accordionRadarOnline = viewChild<MatAccordion>('accordionRadarOnline');
  accordionMarwisOnline = viewChild<MatAccordion>('accordionMarwisOnline');
  accordionRouteOnline = viewChild<MatAccordion>('accordionRouteOnline');
  accordionTaubenOnline = viewChild<MatAccordion>('accordionTaubenOnline');
  accordionAmpelOnline = viewChild<MatAccordion>('accordionAmpelOnline');
  accordionTrendOnline = viewChild<MatAccordion>('accordionTrendOnline');

  userService = inject(UserService);

  onClickSectionCheckbox(section: string, event: MatCheckboxChange) {
    this.clickSectionCheckbox.emit({ section, event });
  }

  onClickAllProducts(section: string, event: MatCheckboxChange) {
    this.clickAllProducts.emit({ section, event });
  }

  onExpandedChanged(section: string) {
    this.expandedChanged.emit(section);
  }

  onUserStationChange(event: MatCheckboxChange, product: any, section: string) {
    this.userStationChange.emit({ event, product, section });
  }

  onUserProductChange(event: MatCheckboxChange, product: any, section: string) {
    this.userProductChange.emit({ event, product, section });
  }

  onCancel() {
    this.cancel.emit();
  }

  onSummarizeUser() {
    this.summarizeUser.emit();
  }
}
